export enum ExcelActions{
    TOGGLE_EXCEL_PANEL = "toggleExcelPanel",
}